/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ActingAsResponseViewModel } from './ActingAsResponseViewModel';
import {
    ActingAsResponseViewModelFromJSON,
    ActingAsResponseViewModelFromJSONTyped,
    ActingAsResponseViewModelToJSON,
} from './ActingAsResponseViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfActingAsResponseViewModel
 */
export interface ResultOfActingAsResponseViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfActingAsResponseViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfActingAsResponseViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfActingAsResponseViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfActingAsResponseViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfActingAsResponseViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfActingAsResponseViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfActingAsResponseViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ActingAsResponseViewModel}
     * @memberof ResultOfActingAsResponseViewModel
     */
    data?: ActingAsResponseViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfActingAsResponseViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfActingAsResponseViewModel interface.
 */
export function instanceOfResultOfActingAsResponseViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfActingAsResponseViewModelFromJSON(json: any): ResultOfActingAsResponseViewModel {
    return ResultOfActingAsResponseViewModelFromJSONTyped(json, false);
}

export function ResultOfActingAsResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfActingAsResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ActingAsResponseViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfActingAsResponseViewModelToJSON(value?: ResultOfActingAsResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ActingAsResponseViewModelToJSON(value.data),
        'Count': value.count,
    };
}

